<app-header-menu [menuHidden]="true"></app-header-menu>

<!-- <div class="main-space">&nbsp;</div> -->
<!-- <app-login-dialog *ngIf="isDialogVisible"></app-login-dialog> -->

<div class="continer" [ngClass]="{ 'menu-hidden': true }">
	<router-outlet></router-outlet>
</div>
<ul id="dock-bar" (mousedown)="$event.stopPropagation()">
	<li>
		<a [routerLink]="'/page/dashboard'"><i class="fas fa-home" [pTooltip]="'g.b.dashboard' | translate"></i></a>
	</li>
	@if (environment.smartyGpt) {
		<li>
			<a
				[ngClass]="{ active: states.isSmartyGptDialogMinimize }"
				[pTooltip]="'SmartyGPT'"
				(click)="showSmartyGptDialog()">
				<div>
					<i class="fas fa-robot"></i>
				</div>
			</a>
		</li>
	}
	<li>
		<a [routerLink]="'/page/smart-report/designer-reports'">
			<i class="fas fa-plus" [pTooltip]="'page.smartyCubes.report-create.parent' | translate"></i>
		</a>
	</li>
</ul>

<p-dialog
	[header]="'form.btn.warn' | translate"
	[(visible)]="isDialogVisible"
	[style]="{ width: '600px', minWidth: 350 }"
	[closable]="false"
	[modal]="true"
	[contentStyle]="{ 'min-height': '5vh' }">
	<label style="font-size: 15px">{{ 'sessionExpiredMessage' | translate }}</label>
	<ng-template #footer>
		<div class="ui-g">
			<div class="ui-g-12 py-2 text-right">
				<button
					pButton
					class="ui-green-button"
					type="button"
					icon="far fa-check-circle"
					(click)="routeToLogin()"
					[label]="'form.btn.ok' | translate"></button>
			</div>
		</div>
	</ng-template>
</p-dialog>

<p-dialog
	[ngClass]="{ hide: states.isSmartyGptDialogMinimize }"
	[(visible)]="states.isSmartyGptDialogVisible"
	[closable]="true"
	[modal]="true"
	[resizable]="false"
	[style]="{ 'min-width': '30vw' }"
	(onHide)="hideSmartyGptDialog()">
	<ng-template #header>
		<span>{{ 'SmartyGPT' }}</span>
		<button class="minimize-button" (click)="minimizeSmartyGptDialog()">
			<i class="pi pi-minus"></i>
		</button>
	</ng-template>
	<div class="ui-g-12 ui-lg-12 ui-md-12 p-0">
		<label>{{ 'index' | translate }}</label>
		<p-select
			class="w-100"
			[options]="indexOptions"
			[filter]="true"
			[(ngModel)]="selectedIndexId"
			appendTo="body"
			(onChange)="selectIndex($event.value)"></p-select>
	</div>
	@if (selectedEsIndex) {
		<div style="width: 70vw; height: 70vh">
			<smarty-gpt
				#smartyGpt
				[index]="selectedEsIndex"
				(createReportEvent)="states.isSmartyGptDialogMinimize = true"></smarty-gpt>
		</div>
	}
</p-dialog>
<p-dialog
	[(visible)]="isShowInteractiveDemoDislay"
	[modal]="true"
	[header]="'interactive-demo.demo-menu-explanation' | translate"
	allowfullscreen
	[style]="{ width: '85%', height: '90%' }">
	<iframe
		src="https://app.sharefable.com/embed/demo/smartycubes-giri-c9wdekmq4faq3zpj"
		width="100%"
		height="100%"
		style="border: none"
		allowfullscreen></iframe>
</p-dialog>
